/**
 * Plain menu data for Certificates feature by role (TR M02 Part B).
 * No imports so this file can be tested cleanly in Node unit tests.
 */

export const CERTIFICATE_MENU_BY_ROLE = {
  associate: [
    {
      titleKey: "sidebar.certificateTemplates",
      path: "/certificate-templates",
      icon: "mdi:certificate-outline",
    },
    {
      titleKey: "sidebar.certificates",
      path: "/certificates",
      icon: "mdi:certificate-outline",
    },
  ],
  teacher: [
    {
      titleKey: "sidebar.certificates",
      path: "/certificates",
      icon: "mdi:certificate-outline",
    },
  ],
  student: [
    {
      titleKey: "sidebar.myCertificates",
      path: "/my-certificates",
      icon: "mdi:certificate-outline",
    },
  ],
  client: [
    {
      titleKey: "sidebar.myCertificates",
      path: "/my-certificates",
      icon: "mdi:certificate-outline",
    },
  ],
};
